import React, { Component } from 'react';
// import '../../assets/style.css';
import {layout,grid,utilities,background,borders,display,custom} from 'reactstrap';
import '../../../scss/style.scss';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/mdn-like.css';
import { Controlled as CodeMirror } from 'react-codemirror2';

require('codemirror/mode/python/python');

import Materi from './Materi/kontenmateri';

import { sebelumnya, berikutnya, getMateriSekarang, pindahBab } from "./Materi/kontenmateri";


class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: '',
      output: '',
      language: 'python3',
      prompt: '',
      response: '',
      materi: { content: "" }
    };

    this.handleSebelumnya = this.handleSebelumnya.bind(this);
    this.handleBerikutnya = this.handleBerikutnya.bind(this);
  const materi = this.props.materiTerpilih;

    // Binding methods
    this.runCode = this.runCode.bind(this);
    this.askGemini = this.askGemini.bind(this);
    this.handleCodeChange = this.handleCodeChange.bind(this);
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
    this.handlePromptChange = this.handlePromptChange.bind(this);
   // this.handleMateriSelect = this.handleMateriSelect.bind(this);
  }
  /*
    handleMateriSelect(babIndex) {
    this.setState({ materi: pindahBab(babIndex) });
  }*/

  componentDidUpdate(prevProps) {
  // cek kalau props.materiTerpilih berubah
    if (prevProps.materiTerpilih !== this.props.materiTerpilih) {
      // update materi sesuai bab baru
      this.setState({
        materi: pindahBab(this.props.materiTerpilih)
      });
    }
  }

  handleSebelumnya() {
    this.setState({ materi: sebelumnya() });
  }

  handleBerikutnya() {
    this.setState({ materi: berikutnya() });
  }

  handleCodeChange(editor, data, value) {
    this.setState({ code: value });
  }

  handleLanguageChange(e) {
    this.setState({ language: e.target.value });
  }

  handlePromptChange(e) {
    this.setState({ prompt: e.target.value });
  }

  

  async runCode() {
    this.setState({ output: '⏳ Memproses...' });
    try {
      const res = await fetch("https://emkc.org/api/v2/piston/execute", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          language: this.state.language,
          version: "*",
          files: [{ content: this.state.code }]
        })
      });
      const result = await res.json();
      this.setState({
        output: result.run.stdout || result.run.stderr || "❌ Tidak ada output"
      });
    } catch (err) {
      console.error(err);
      this.setState({ output: "❌ Gagal menjalankan kode." });
    }
  }

  async askGemini() {
    if (!this.state.prompt.trim()) {
      alert("Pertanyaan tidak boleh kosong!");
      return;
    }
    this.setState({ response: "⏳ Meminta jawaban dari Gemini..." });
    try {
      const res = await fetch("https://generativelanguage.googleapis.com/v1beta/models/gemini-2.0-flash:generateContent?key=AIzaSyBlWnjGK706uFhgHY_J_40Nr2hMnjykczM", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
         body: JSON.stringify({
        contents: [
          {
            parts: [{ text: this.state.prompt }]
          }
        ]
      })
      });
      const data = await res.json();
      this.setState({
        response: 
        data &&
        data.candidates &&
        data.candidates[0] &&
        data.candidates[0].content &&
        data.candidates[0].content.parts &&
        data.candidates[0].content.parts[0] &&
        data.candidates[0].content.parts[0].text
          ? data.candidates[0].content.parts[0].text
          : "❌ Jawaban kosong"
      });
    } catch (err) {
      console.error(err);
      this.setState({ response: "❌ Gagal mendapatkan jawaban dari Gemini." });
    }
  }



  render() {
    return (
    <div className="container-fluid px-0 py-0 mb-0 full-height mh-100 animated fadeIn">
      <div className="row no-gutters h-100 border-bottom" style={{ minHeight: 'calc(100vh - 110px)' }}>
        <div className="col-4 py-0 shadow p-3 mb-0 bg-white rounded d-flex flex-column full-height overflow-auto">
          <div className="">
            <h3 className="text-dark" >Materi Pembelajaran</h3>
            <div className="flex-fill text-dark "  dangerouslySetInnerHTML={{ __html: this.state.materi.content }}></div>
            <div style={{ marginTop: '100px' }}>
              <button onClick={this.handleSebelumnya}>Sebelumnya</button>
              <button onClick={this.handleBerikutnya}>Berikutnya</button>
            </div>
          </div>
        </div> 

        <div className="col-5 d-flex flex-column h-100 pl-2">
          <div className="h-50 flex-shrink-0 border-bottom">
            <h3 className="text-dark">Editor Kode</h3>
            <CodeMirror
              value={this.state.code}
              options={{
                mode: 'python',
                theme: 'mdn-like',
                lineNumbers: true,
              }}
              onBeforeChange={this.handleCodeChange}
            />
            <div style={{ margin: '10px' }}>
              <label htmlFor="language">Pilih Bahasa:</label>
              <select
                id="language"
                value={this.state.language}
                onChange={this.handleLanguageChange}
              >
                <option value="python3">Python</option>
                <option value="cpp">C++</option>
              </select>
              <button onClick={this.runCode}>Compile</button>
            </div>
          </div>

          <div className="h-50 flex-grow overflow-auto min-h-0">
            <h3 className="text-dark">Terminal</h3>
            <div className="">
              <pre>{this.state.output}</pre>
            </div>
            
          </div>
        </div>

        <div className="col-3 text-dark">
          <h2 className="text-dark">Chat with Gemini</h2>
          <textarea
            rows="4"
            placeholder="Tulis pertanyaan kamu..."
            value={this.state.prompt}
            onChange={this.handlePromptChange}
          />
          <button onClick={this.askGemini}>Kirim ke Gemini</button>
          <div>{this.state.response}</div>
        </div>
      </div>
      </div>
    );
  }
}

export default Dashboard;

//<a href="login/logout.php">Logout</a>
//{this.state.materi}
//<Materi/>
